/* eslint-disable max-len */
import React, {
  useEffect, useState, ChangeEvent, MouseEvent, KeyboardEvent,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, IconButton, InputBase } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import posthog from 'posthog-js';
import { ellipsis } from 'polished';

import Color from '@tool/color';
import moHeader, {
  changeValue, changeJobname,
} from './store/index';
import {
  SearchIcon, IconX11, IconX12, IconX13, VPlay,
} from '@styled/icon';
import AdSlick from './ad-slick';
import moUser from '@store/user';
import moSkin from '@store/skin';
import moHome, { setUrl, toggleOpen } from '@store/home';

interface IProps {}
interface IState {}

const DInput = styled(InputBase)(() => ({
  width: '390px',
  height: '36px',
  padding: '0 0 0 10px',
  borderBottom: 'none',
  borderRadius: '5px',
  border: `1px solid ${Color.ec}`,
  backgroundColor: Color.fff,

  '& input': {
    padding: 0,
    fontSize: '12px',
    fontWeight: 500,
    color: Color.c55,
  },
  '& input::placeholder': {
    opacity: 1,
    color: Color.cf,
  },
}));

const DIconButton = styled(IconButton)(() => ({
  padding: '6px 10px',
  borderRadius: 0,
  '&:hover': { backgroundColor: Color.blackColor(0) },
}));

const DButton = styled(Button)(() => ({
  height: '36px',
  padding: '0 8px',
  marginLeft: '10px',
  marginBottom: '5px',
  fontSize: '12px',
  fontWeight: 500,
  borderRadius: '5px',
  color: Color.c55,
  backgroundColor: Color.primaryColor(0.1),

  '&:hover': { backgroundColor: Color.primaryColor(0.1) },
}));

{/** 薪酬方案工具 */}
const PopSalary = (props: IProps, state: IState) => {
  const { isLogin, isStructureExpired, isAnalysisExpired } = moUser;
  const navi = useNavigate();
  const { popMarket, jobname, subJobList } = moHeader;
  const { modules, partner } = moSkin;
  const list = [
    {
      imageUrl: 'https://file.smartsalary.cn/web-img%402.0/home/nav003.png',
      toUrl: '/market/insight',
    },
  ];

  useEffect(() => {
    return () => {};
  }, []);

  const onQuery = (ev?: MouseEvent) => {
    ev?.stopPropagation();
    posthog.capture('导航市场薪酬查询人数', {});
    if (isEmpty(jobname)) {
      let newJob = '';
      if (!isEmpty(subJobList)) newJob = subJobList[0].job_name || '';

      if (!newJob) {
        changeJobname('');
        localStorage.setItem('jobname', '');
        window.location.href = '/market/marketpay';
      } else {
        changeJobname('');
        localStorage.setItem('jobname', newJob);
        window.location.href = '/market/result';
      }
    } else {
      changeJobname('');
      localStorage.setItem('jobname', jobname);
      window.location.href = '/market/result';
    }
  };

  const onPress = (ev: KeyboardEvent) => {
    ev.stopPropagation();
    posthog.capture('导航市场薪酬查询人数', {});
    if (ev.key === 'Enter') onQuery();
  };

  // 年度调薪策略
  const onJumpSalaryBoard = () => {
    posthog.capture('导航年度调薪策略点击人数', {});
    window.location.href = '/market/salary-board';
  };

  // 公司薪酬诊断
  const onJumpCompensation = () => {
    posthog.capture('导航公司薪酬诊断点击人数', {});
    if (isLogin && !isAnalysisExpired) window.location.href = '/compensation';
    else window.location.href = '/home/compensation';
  };

  // 薪酬体系设计
  const onJumpOveralldesign = () => {
    posthog.capture('导航薪酬体系设计点击人数', {});
    if (isLogin && !isStructureExpired) window.location.href = '/overalldesign';
    else window.location.href = '/home/overalldesign';
  };

  // 岗位价值评估
  const onCompensation1 = () => {
    // posthog.capture('顶部导航栏跳转-岗位价值评估', {});
    if (isLogin && !isAnalysisExpired) window.location.href = '/compensation';
    else window.location.href = '/home/compensation';
  };

  // 内外部薪酬差异
  const onCompensation2 = () => {
    // posthog.capture('顶部导航栏跳转-内外部薪酬差异', {});
    if (isLogin && !isAnalysisExpired) window.location.href = '/compensation';
    else window.location.href = '/home/compensation';
  };

  // 薪酬体系
  const onOverallDesign = () => {
    // posthog.capture('顶部导航栏跳转-薪酬体系', {});
    if (isLogin && !isStructureExpired) window.location.href = '/overalldesign';
    else window.location.href = '/home/overalldesign';
  };

  // 点击热门职位
  const onHotJob = (value: string) => {
    // posthog.capture(`顶部导航栏跳转-${value}`, {});
    changeJobname('');
    localStorage.setItem('jobname', value);
    window.location.href = '/market/result';
  };

  // 播放视频
  const onPlay = () => {
    changeValue('popSalary', false);
    setUrl('https://file.smartsalary.cn/v2-video/%E6%98%93%E8%B7%AF%E8%81%8C%E5%9C%BA%E7%94%A8%E8%96%AA%E8%AF%B4-%E7%AC%AC%E4%B8%80%E6%9C%9F02_%E7%AC%AC%E4%BA%8C%E8%8A%82.mp4');
    toggleOpen(true);
  };

  return (
    <section aria-hidden="true" className="header-pop_100"
      onMouseEnter={() => changeValue('popSalary', true)}
      onMouseLeave={() => changeValue('popSalary', false)}>
      <section className="pop-1010">
        <section className="pop-box_100">
          <i className="tri-10 tri-12" />
          <section className="box-10">
            <section className="search-11">
              <DInput value={jobname}
                endAdornment={(
                  <DIconButton onClick={onQuery}>
                    <SearchIcon color={Color.primary} />
                  </DIconButton>
                )}
                onChange={(ev: ChangeEvent<HTMLInputElement>) => changeJobname(ev.target.value)}
                onKeyPress={onPress}
                placeholder="请输入职位名称搜索" />
              <section className="search-101">
                {!isEmpty(subJobList) ? (
                  <DButton onClick={() => onHotJob(subJobList[0]?.job_name)}>
                    {subJobList[0]?.job_name}
                  </DButton>
                ) : null}
                <DButton onClick={onCompensation1}>岗位价值评估</DButton>
                <DButton onClick={onCompensation2}>内外部薪酬差异</DButton>
                <DButton onClick={onOverallDesign}>薪酬体系</DButton>
              </section>
            </section>
            <section className="card-11">
              {/* TODO: 2024-06-17 隐藏"年度调薪策略"入口
                  @reason 数据已停止更新，避免客户看到产生不良印象
                  @requirement Bob 要求在所有平台（含换肤平台）隐藏此入口
                  {modules.includes('salaryStrategy') ? (
                    <section className="card-101" aria-hidden="true" onClick={onJumpSalaryBoard}
                      data-attr="ph-capture" data-custom-id="salary01">
                      <p className="line-101">
                        <IconX11 />
                        <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>年度调薪策略</b>
                      </p>
                      <span style={{ ...ellipsis('100%', 2) }}>
                        确定调薪比例，设置调薪矩阵
                      </span>
                    </section>
                  ) : null}
              */}
              {modules.includes('salaryAnalysis') ? (
                <section className="card-101" aria-hidden="true" onClick={onJumpCompensation}
                  data-attr="ph-capture" data-custom-id="salary02">
                  <p className="line-101">
                    <IconX12 />
                    <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>公司薪酬诊断</b>
                  </p>
                  <span style={{ ...ellipsis('100%', 2) }}>
                    内部公平性、外部竞争性分析，数据一键智能导入
                  </span>
                </section>
              ) : null}
              {modules.includes('salaryStructure') ? (
                <section className="card-101" aria-hidden="true" onClick={onJumpOveralldesign}
                  data-attr="ph-capture" data-custom-id="salary03">
                  <p className="line-101">
                    <IconX13 />
                    <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>薪酬体系设计</b>
                  </p>
                  <span style={{ ...ellipsis('100%', 2) }}>
                    体系设计与成本测算一体化，体系设计过程可视化
                  </span>
                </section>
              ) : null}
            </section>
          </section>

          {modules.includes('video') ? (
            <section className="box-20">
              <section className="box-21">
                <AdSlick list={list} />
              </section>
              <section className="box-22">
                <p className="title-1122">大厂高薪抢人是 [恶性竞争] 吗？</p>
                <p className="img-11220" aria-hidden="true" onClick={onPlay}>
                  <img src="https://file.smartsalary.cn/web-img%402.0/home/v-salary.png"
                    alt="cover" className="img-1122" />
                  <VPlay />
                </p>
              </section>
            </section>
          ) : null}

        </section>
      </section>
    </section>
  );
};

export default observer(PopSalary);
